<script setup lang="ts">
import NotFound from '@/components/layout/NotFound.vue';

definePage({ meta: { title: 'layout.notFoundTitle' } });
</script>

<template>
  <NotFound />
</template>

<style scoped>

</style>